<div class="master-modal reviepw_items_modal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <!-- Modal-Header -->
      <div class="modal-header">
        <h4 class="modal-title"> Add Price Unit </h4>
        <div class="modal_close_btn">
          <span (click)="closeDialog('no')" class="modal-close"><i class="material-icons">close</i></span>
        </div>
      </div>
      <form [formGroup]="priceUnitForm" (ngSubmit)="addSupplyCategory()">
      <!-- Modal content-->
        <perfect-scrollbar class="modal-body-scrollbar">
          <div mat-dialog-content>
            <div class="modal-body">
               <mat-form-field appearance="outline">
                 <input matInput formControlName="name" placeholder="Enter name"/>
                 <mat-error *ngIf="name.invalid && (name.dirty || name.touched)">
                    <span *ngIf="name.hasError('required')">
                      Name is required  </span>
                 </mat-error>
               </mat-form-field>
            </div>
          </div>
        </perfect-scrollbar>
        <!-- Modal-Footer -->
        <div class="modal-footer">
          <div mat-dialog-actions class="modal_footer">
            <button type="button" mat-button (click)="closeDialog('no')" class="modal-cancel-btn modal-footer-btn">
              <span> Cancel </span>
            </button>
            <button type="submit" mat-button class="modal-save-btn global-btn modal-footer-btn">
              <span> Save </span>
            </button>
          </div>
        </div>
      </form>

    </div>
  </div>
</div>

